import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography, useTheme } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ChatLabel } from "./ChatLabel";
import { IGroupedConversations } from "../Interfaces";

const GroupedConversations: React.FC<IGroupedConversations> = ({
  groupTitle,
  conversations,
  chatId,
  editChatTitleId,
  open,
  isContextMenuOpen,
  contextMenuOpenId,
  handleClick,
  handleContextMenuButtonClick,
  handleTitleRename,
  setEditChatTitleId,
  handleNavigate,
  isConversationLoading,
  handleSnackbar,
}) => {
  const theme = useTheme();

  return (
    <Accordion
      key={groupTitle}
      expanded={open}
      onChange={handleClick}
      disableGutters
      elevation={0}
      square
      slotProps={{ transition: { unmountOnExit: true } }}
      sx={{ "&:before": { display: "none" } }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          padding: 1,
          px: 3,
          minHeight: "unset",
          borderBottom: `1px solid ${theme.palette.divider}`,
          background: theme.palette.grey[200],
          "& .MuiAccordionSummary-content": { margin: 0 },
        }}
      >
        <Typography sx={{ textTransform: "uppercase", fontWeight: theme.typography.fontWeightSemiBold }}>
          {groupTitle}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        <Stack>
          {conversations.map((chat) => (
            <ChatLabel
              key={chat.conversationId}
              hasBorder={false}
              active={isContextMenuOpen && contextMenuOpenId === chat.conversationId}
              name={chat.title ?? "New Chat"}
              handleContextMenuButtonClick={(event) => handleContextMenuButtonClick(event, chat)}
              isVisible={chat.conversationId === chatId || (isContextMenuOpen && contextMenuOpenId === chat.conversationId)}
              id={chat.conversationId}
              isEnabledEdit={chat.conversationId === editChatTitleId}
              renameTitle={handleTitleRename}
              setEditChatTitleId={setEditChatTitleId}
              handleNavigate={handleNavigate}
              isConversationLoading={isConversationLoading}
              handleSnackbar={handleSnackbar}
            />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default GroupedConversations;
